export enum RewardsStyleVariant {
  Primary = 'Primary',
  Secondary = 'Secondary',
}

export type WithStyleVariant = {
  variant?: RewardsStyleVariant;
};
